import React, { useState } from "react";
import { MainContainer } from "../Components/Elements";
import PagesNav from "../Components/PagesNav";
import SearchInput from "../Components/SearchInput";
import DateRangePickerInput from "./DateRangePicker";
import Shimmer from "../Components/Shimmer";
import downlaodBtn from "../assets/icons/financialstatementIcons/Frame 1171275847.png"
import PaidHooks from "../hooks/Financial statement/PaidHooks";

const Paid = () => {
    const {
        NavItems,
        setSearch,
        handleRangeChange
      } = PaidHooks();
      return (
        <>
          <MainContainer>
            <div className="d-flex gap-3 mb-3 align-items-center">
               <DateRangePickerInput onRangeChange={handleRangeChange}/>
              <PagesNav links={NavItems} />
              <div className="d-flex gap-2 align-items-center">
                <SearchInput search={(e) => setSearch(e.target.value)} />
                <img src={downlaodBtn} className="w-100" alt="downlaodBtn" />
              </div>
            </div>
    
            <div className="row" >
        <div className='border-bottom pb-0 ' >
    <div className='py-4 d-flex justify-content-between px-3 bg-light'>
      <div className='d-flex gap-5 align-items-center'>
        <h6>Amount due</h6>
          </div>
      <div className="d-flex gap-3">
      <p className="text-muted">20 / 6 / 2025</p>
     <h6 className="text-danger">Relay</h6>
      </div>
    
            </div>
          <div className="row px-3 py-3 mx-1" style={{height:"200px" , overflowY:"scroll"}}>
            <div className="col-md-12">
              <h4 className="fw-light">Tarek El.Shazly</h4>
            </div>
            <div className="col-md-3">
            <p className='fw-bold text-main'>Type :  </p>
            </div>
            <div className="col-md-3">
            <p className='fw-bold text-main'>Project :  </p>
            </div>
            <div className="col-md-3">
            <p className='fw-bold text-main'>Unit Type :  </p>
            </div>
            <div className="col-md-3">
            <p className='fw-bold text-main'>Phone :   </p>     
            </div>
            <p> <span className="fw-bold">Note :</span> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s Lorem Ipsum has been the industry's standard dummy 
            text ever since the 1500s  </p>
          </div>
    </div>
        </div> 
                {Array.from({ length: 1 }, (_, index) => (
                <div key={index} className="row py-3">
                    <Shimmer style={{ height: "200px", borderRadius: "20px" }} />
                </div>
              ))}
          </MainContainer>
    
         
        </>
      );
}

export default Paid